import type { JSX, PropsWithChildren } from 'react';

/** Header plus a centred card; shared by the login screens and the gate's dead-end screens. */
export const AuthLayout = ({ children }: PropsWithChildren): JSX.Element => (
  <main className="ow-page">
    <header className="ow-header">
      <img className="ow-logo" src="/icons/inhouse-trimmed.svg" alt="" />
      <span className="ow-title">Invite Owner</span>
    </header>
    <div className="ow-card">{children}</div>
  </main>
);
